export enum SettingsSubpages {
  Connections = "connections",
  SdkBundles = "sdks/bundles",
  SdkScripts = "sdks/scripts",
  ApiKeys = "api-keys",
  AgentCredentials = "agent-credentials",
  AiUsageLimits = "ai-usage-limits",
  Users = "users",
  AuditLogs = "audit-logs",
  Powertools = "powertools",
  Sessions = "sessions",
}

export const isSdkSettingsSubpage = (subpage: SettingsSubpages): boolean =>
  subpage === SettingsSubpages.SdkBundles ||
  subpage === SettingsSubpages.SdkScripts;
